import "./thinking-animation.css";

const ThinkingAnimation = () => (
  <div className="text-sm text-indigo-600 thinking">
    <span></span>
    <span></span>
    <span></span>
  </div>
);

export default ThinkingAnimation;
